

<template>
  <div class="signup app-content">
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-2 pb-2">
          <div class="col-12">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./news'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.study_text")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12 py-2">
            <p class="article_title mb-12"><b>{{$t("message.texts_learning")}}</b></p>
            <b-card >
              <p>フィルター: 
                  <b-nav-item-dropdown id="my-nav-dropdown" v-model="selectInd" class='setting-down selectNav py-0 pr-0 myNav  header-dropdown-menu'>
                    <b-dropdown-item v-for='(row, index) in industries' :key='index' class='text-black'  @click="switchIndustry(row.id)">{{ $t("message.industry_id_" + row.id) }}</b-dropdown-item>
                  </b-nav-item-dropdown>
              </p>
              <div v-for='(row, index) in learning_texts' :key='index'>
                <div v-if="currentIndustry == row['industry_id']">
                  <h5 v-if='checkIndustry(row["industry_id"], index)' class='pt-4'>{{$t("message.industry_id_" + row['industry_id']) }}</h5>
                  <a :href="row['link']" class="mgr-20">{{row['small_industry']}} {{row["title"]}}</a>
                </div>
              </div>
            </b-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
export default {
  components: {
  },
  data () {
    return {
      idToken: localStorage.idToken,
      learning_texts: {},
      industries: {},
      currentIndustry: "1",
      selectInd: ""
    }
  },
  methods: {
    checkIndustry(small, index){
      if(index != 0){
        if(small == this.learning_texts[index - 1]['industry_id']){
          return false
        }else if(small == ''){
          return false
        }else{
          return true
        }
      }else{
        return true
      }
    },
    checkSmall(small, index){
      if(index != 0){
        if(small == this.learning_texts[index -1]['small_industry']){
          return false
        }else if(small == ''){
          return false
        }else{
          return true
        }
      }
    },
    switchIndustry(ind) {
      this.currentIndustry = ind
      this.selectInd = ind
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API + "/user/available_industry", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industries = response.data
      })



    this.$store.commit('setLoading', false)
  },
  computed: {
    ...mapState({
        dataJson: state => state.jsonData.jsonData,
        lang: state => state.language,
    }),
  },
  watch:{
    lang:{
      handler: function(){
        console.log('this is data',this.TRANS_LANGUAGE_LIST[this.lang])
        axios
        .get(process.env.VUE_APP_API + "/learning_texts?lang=" + this.TRANS_LANGUAGE_LIST[this.lang], {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            console.log(response.data)
            this.learning_texts = response.data.learning_texts
        }).catch(error => {
            this.errorNotify(error.response)
        })
      },
      immediate: true
    },
  }
}
</script>

<style scoped lang="scss">
.article_title{
  font-weight: bold;
  font-size: 16px;
}

.news-li{
  list-style: none;
}

.index_orange{
  font-weight: bold;
  color: #F29147;
}

.index_red{
  font-weight: bold;
  color: #E60028;
}

.recomend-card{
  background:linear-gradient(67.94deg, #000054 0%, rgba(0, 0, 84, 0.5) 100%);
}
.solved-probrem{
  background: linear-gradient(67.94deg, #00BDE6 0%, rgba(0, 189, 230, 0.5) 100%);
}

.look_solved{
  background: linear-gradient(67.94deg, #F29147 0%, rgba(242, 145, 71, 0.5) 100%);
}

.billing{
  background: #F29147;
  color: #FFFFFF;
  font-size: 14px;
}

.mb-12{
  margin-bottom: 12px;
}
.more{
  background: #FFFFFF;
  color: #000000;
  border: #FFFFFF;
}
</style>
